import { useEffect, useState } from "react";
import TopHeadScreen from "../../component/layout/tophead";
import SidebarScreen from "../../component/layout/sidebar";
import AuthFooterScreen from "../../component/layout/authfooter";
import {
  getAdmin,
  getChatBoardList,
  messageSend,
} from "../../service/apis/message.api";
import { showError } from "../../utils/Common";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import {
  addMessage,
  setActiveChatId,
  setChatHistory,
} from "../../store/chat.store";
import EmployerHeaderScreen from "../../component/layout/employerheader";
import EmployerSidebarScreen from "../../component/layout/employer-sidebar";
import AgentSidebarScreen from "../../component/layout/agent-sidebar";
import AgentTopHeadScreen from "../../component/layout/agent-header";
import ChatWindow from "./common/chat";
import { useParams } from "react-router-dom";

const JobsMessageScreen = () => {
  const { user } = useSelector((state: RootState) => state.authSlice);
  const [newMessage, setNewMessage] = useState("");
  const { chatId } = useParams<{ chatId: string }>();

  const { messageList, chatHistory, activeChatId } = useSelector(
    (state: RootState) => state.chatSlice
  );

  const [adminDetails, setAdminDetails] = useState<any>(null);

  const dispatch = useDispatch();

  // const getAllMessages = async () => {
  //   try {
  //     const response = await getMessageList();
  //     dispatch(setMessageList(response?.result));
  //     if (response?.result && response?.result.length > 0) {
  //       getChatList(response?.result[0]?._id);
  //     }
  //   } catch (error: any) {
  //     showError(error?.message);
  //   } finally {
  //   }
  // };
  useEffect(() => {
    // console.log(chatId, "chatId");
    if (chatId) {
      getChatList(chatId);
    }
    if (messageList && messageList.length > 0) {
      getChatList(messageList[0]?._id);
    }
    getAdminDetails();
    // eslint-disable-next-line
  }, [chatId]);
  // const openChat = async (item: MsgList) => {
  //   if (user && user?.role == "jobseeker") {
  //     NavigateTo(
  //       `${AppRoute.JOBSEEKER_MESSAGE}/${chatId ? chatId : item?._id}`
  //     );
  //   } else if (user && user?.role == "localagents") {
  //     NavigateTo(`${AppRoute.AGENT_MESSAGE}/${chatId ? chatId : item?._id}`);
  //   } else if (user && user?.role == "employer") {
  //     NavigateTo(`${AppRoute.EMPLOYER_MESSAGE}/${chatId ? chatId : item?._id}`);
  //   }
  //   getChatList(item);
  // };

  const getAdminDetails = async () => {
    try {
      const response = await getAdmin();
      // console.log("response", response);
      setAdminDetails(response?.admin);
    } catch (error: any) {
      showError(error?.message);
    } finally {
    }
  };

  const getChatList = async (chatId: string = "") => {
    try {
      const response = await getChatBoardList(chatId);
      let messages = response?.result;
      const sortedMessages = [...messages].sort((a, b) => {
        const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
        const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
        return dateA - dateB;
      });
      dispatch(setChatHistory(sortedMessages));
    } catch (error: any) {
      showError(error?.message);
    } finally {
    }
  };

  const sendMessage = async () => {
    if (!newMessage.trim()) {
      return showError("Message cannot be empty");
    }

    const newChatMessage = {
      content: newMessage,
      receiverID: chatId || activeChatId ? "" : adminDetails?.id,
      chatId: chatId ? chatId : activeChatId ? activeChatId : "",
    };

    try {
      const response = await messageSend(newChatMessage);
      if (response?.status === 200) {
        setNewMessage("");
        dispatch(addMessage(response?.message?.resentMessage));
        dispatch(setActiveChatId(response?.message?.resentMessage?.chat?._id));
        // getAllMessages();
      }
    } catch (error: any) {
      showError("Error sending message");
    } finally {
    }
  };

  return (
    <>
      <div className="main">
        <section className="profileJoblisting-area">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 sidebar  position-relative p-0">
                {user && user?.role === "jobseeker" && <SidebarScreen />}
                {user && user?.role === "localagents" && <AgentSidebarScreen />}
                {user && user?.role === "employer" && <EmployerSidebarScreen />}
              </div>
              <div className="col-lg-10 rightcontent p-0">
                {user && user?.role === "jobseeker" && <TopHeadScreen />}
                {user && user?.role === "localagents" && <AgentTopHeadScreen />}
                {user && user?.role === "employer" && <EmployerHeaderScreen />}
                <div className="message-main-holder">
                  <div className="row">
                    {/* <div className="col-lg-3">
                      <MessageList
                        messageList={messageList}
                        openChat={openChat}
                      />
                    </div> */}
                    {/* {chatId ? ( */}
                    <ChatWindow
                      chatHistory={chatHistory}
                      user={user}
                      newMessage={newMessage}
                      setNewMessage={setNewMessage}
                      sendMessage={sendMessage}
                      adminDetails={adminDetails}
                    />
                    {/* ) : (
                      <div className="col-lg-9">
                        <MessageBlankScreen />
                      </div>
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      <AuthFooterScreen />

      {/* <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="findajobmodal"
        centered
      >
        <Modal.Body>
          <div className="afterapplied">
            <h3>Software Engineer</h3>
            <div className="aplyinfo">
              <h4>
                <strong>Job Title:</strong> Software Engineer
              </h4>
              <h4>
                <strong>Company Name:</strong> TechWave Solutions
              </h4>
              <h4>
                <strong>Location:</strong> San Francisco, CA
              </h4>
              <h4>
                <strong>Application Date:</strong> Oct 12, 2024
              </h4>
              <h4>
                <strong>Job Type:</strong> Full-time
              </h4>
              <h4>
                <strong>Status:</strong> Applied
              </h4>
              <h4>
                <strong>Salary Range:</strong> $900 - $1200/month
              </h4>
            </div>
          </div>
        </Modal.Body>
      </Modal> */}
    </>
  );
};
export default JobsMessageScreen;
